import { atom } from "recoil";

export const currentIngtegrationsState = atom({
  key: "currentIngtegrations",
  default: [],
});
